import { WAIT_STATE } from '@/views/Delivery/kitchenWaitConstants'

const URGENCY_GROUP = {
  WAITING: 0,
  NOT_ARRIVED: 1,
  NOT_COUNTED: 2,
  STARTED: 3
}

const GROUP_BY_STATE = {
  [WAIT_STATE.WAITING]: URGENCY_GROUP.WAITING,
  [WAIT_STATE.WAITING_ARRIVAL]: URGENCY_GROUP.NOT_ARRIVED,
  [WAIT_STATE.BEFORE_SCHEDULE]: URGENCY_GROUP.NOT_ARRIVED,
  [WAIT_STATE.SECOND_TRIP]: URGENCY_GROUP.NOT_COUNTED,
  [WAIT_STATE.STARTED]: URGENCY_GROUP.STARTED
}

function groupOf (route) {
  const group = GROUP_BY_STATE[route.state]
  return group === undefined ? URGENCY_GROUP.NOT_COUNTED : group
}

function compareRoutes (first, second) {
  const groupDifference = groupOf(first) - groupOf(second)
  if (groupDifference !== 0) {
    return groupDifference
  }
  if (groupOf(first) === URGENCY_GROUP.WAITING && first.wait_seconds !== second.wait_seconds) {
    return second.wait_seconds - first.wait_seconds
  }
  return first.route_id - second.route_id
}

export function sortRoutesByUrgency (routes) {
  return [...routes].sort(compareRoutes)
}
